import { useCallback, useEffect, useState } from 'react';
import { screens } from '../style';

type Breakpoint = keyof typeof screens | number;

export const useIsWithinTailWindBreakpoint = (breakpoint: Breakpoint) => {
  const createMediaQuery = useCallback(() => {
    const width = typeof breakpoint === 'number' ? breakpoint : parseInt(screens[breakpoint].replace('px', ''));

    return window.matchMedia(`(max-width: ${width}px)`);
  }, [breakpoint]);

  const [matches, setMatches] = useState(() => createMediaQuery().matches);

  useEffect(() => {
    const mediaQuery = createMediaQuery();
    const updateMatch = () => setMatches(mediaQuery.matches);

    mediaQuery.addEventListener('change', updateMatch);
    // not sure we need this
    // updateMatch(); // ensure match is set immediately in case of layout shift
    return () => mediaQuery.removeEventListener('change', updateMatch);
  }, [createMediaQuery]);

  return matches;
};
